import React from "react";
import PropTypes from "prop-types";

const Notify = (props) => {
  const { count } = props;

  if (count === 0) return;

  return <div className="admin-menu-lists-item__notification">{count}</div>;
};

Notify.propTypes = {
  count: PropTypes.number.isRequired,
};

export default Notify;
